<template>
	<div class="navbar">
		<a :href="mainSiteLink" class="navbar__image" target="_blank">
			<img src="https://incognitocr.ru/images/dest/logo-new.svg" alt="logo">
		</a>
		<div class="navbar__content">
			<ProfileMain
				class="profile-main"
				:phoneAuth="store.state.user.app_auth === 'phone'"
				:hasASP="store.state.user.user_state === 'current_with_ahs'"
				:fullName="fullName" :phone="store.state.user?.phone.number"
				:dataReady="dataReady"/>
			<nav class="nav">
				<ul class="nav__list">
					<li class="nav__item" :class="{
						'active': (
						router.currentRoute.value.name === 'home'
						|| router.currentRoute.value.name === 'info-status'
						|| router.currentRoute.value.name === 'main-page'
						|| router.currentRoute.value.name === 'approved'
						|| router.currentRoute.value.name === 'payout-status'
						)
					}">
						<button @click="goHome">Главная</button>
					</li>
					<li class="nav__item" :class="{'active': router.currentRoute.value.name === 'archieve'}">
						<button @click="router.push({name: 'archieve'})">История</button>
					</li>
					<li class="nav__item">
						<button class="nav__link" @click="store.dispatch('logOut')">Выйти</button>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script setup>
import ProfileMain from '@/entities/components/ProfileMain/ProfileMain.vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const store = useStore();
const fullName = computed(() => `${store.state.user?.first_name} ${store.state.user?.last_name}`);
const dataReady = computed(() => {
	if (store.state.user.app_auth === 'phone') {
		return !!store.state.user?.phone.number;
	}

	return !!(store.state.user?.first_name && store.state.user?.last_name && store.state.user?.phone.number);
});

function goHome() {
	router.push({ name: 'home' });
	store.commit('steps/SET_COMPONENT_STEP', 1);
	// window.location.href = '/';
	// store.commit('historyFeatures/setHistoryItems', {});
}

const mainSiteLink = computed(() => (process.env.NODE_ENV === 'development' ? 'http://incognito.beta/' : 'https://incognitocr.ru/'));

</script>

<style lang="scss" scoped>
@import "navbar";
</style>
